import { render, staticRenderFns } from "./Datalist.vue?vue&type=template&id=33c96d71&scoped=true&"
import script from "./Datalist.vue?vue&type=script&lang=js&"
export * from "./Datalist.vue?vue&type=script&lang=js&"
import style0 from "./Datalist.vue?vue&type=style&index=0&id=33c96d71&lang=scss&scoped=true&"
import style1 from "./Datalist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c96d71",
  null
  
)

export default component.exports